import styled, { css } from "styled-components"
import { CursorCrosshairBlack } from "shared/Styles/Cursors"

export const Wrapper = styled.ul`
  display: flex;
  flex-direction: row;
`

const linkStrike = css`
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  background: ${({ color, theme }) => (color ? color : theme.color.black)};
  top: 50%;
  left: 50%;
`

export const LinkWrapper = styled.li`
  position: relative;
  overflow: hidden;
  color: ${({ color }) => color};
  transition: 0.5s color ease-in-out;
  &:not(:last-child) {
    margin-right: 12px;
    @media screen and (min-width: ${props =>
        props.theme.breakpoints.phoneBig}) {
      margin-right: 30px;
    }
  }
  &::after {
    ${linkStrike}
    opacity: 0;
    transform: translate(-200%, -50%);
    transition: transform 0.4s ease-in;
  }
  &::before {
    ${linkStrike}
    transform: translate(200%, -50%);
    transition: transform 0.4s ease-in;
  }
  &:hover::after {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
  &:hover::before {
    transform: translate(-50%, -50%);
  }
`

export const Link = styled.a`
  text-decoration: none;
  font-size: 15px;
  font-family: "sharp_groteskmedium_20", Arial, Helvetica, sans-serif;
  text-transform: uppercase;
  color: inherit;
  ${CursorCrosshairBlack}
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phoneBig}){
    font-size: 10px;  
  }
`
